import React from 'react';
import styles from '../Tabs.module.scss';
import PropTypes from 'prop-types';

const Tab = ({children, id, shy, disabled, isDefault, ...props}) => {

    const classes = [styles.activeTab];
    if (disabled) classes.push(styles.activeTabDisabled);
    if (shy) classes.push(styles.activeTabShy);

    return (
        <div className={classes.join(' ')} {...props}>
            {children}
        </div>
    );
};

Tab.propTypes = {
    id: PropTypes.string.isRequired,
    children: PropTypes.any,
    title: PropTypes.any,
    isDefault: PropTypes.bool,
    disabled: PropTypes.bool,
    shy: PropTypes.bool
};

Tab.defaultProps = {
    id: null,
    children: null,
    title: 'Tab',
    isDefault: false,
    disabled: false,
    shy: false
};

export default Tab;
